<template>
  <section
    class="component-f67cbdf8"
    resmed-component-name="feature_background_title_sub-head"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-md-9 col-xl-8 text-center">
            <h1
              v-bind:class="[acf.layout['headline-size']]"
              v-html="acf.headline"
            ></h1>
            <h4 v-if="acf.content" v-html="acf.content"></h4>

            <div v-if="acf.cta" class="cta mt-4">
              <a
                v-for="item in acf.cta"
                v-bind:href="item.cta.href"
                v-bind:target="item.cta.target"
                class="ctaButton cta-pill hallow-white icon right-arrow mr-3"
                >{{ item.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-f67cbdf8", // feature_background_title_sub-head
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-f67cbdf8 {
  background-position: center center;
  background-repeat: no-repeat;
  padding: 5rem 0;

  &:first-of-type {
    @media (min-width: 768px) {
      padding: 6rem 0 5rem 0;
    }

    @media (min-width: 992px) {
      padding: 12rem 0 5rem 0;
    }

    @media (min-width: 1200px) {
      padding: 12.5rem 0 4rem 0;
    }
  }
}

.component {
  h1 {
    margin: 0 0 1rem 0;

    &.s54 {
      // default size
    }

    &.s81 {
      @extend %display;
    }
  }

  h1,
  h4 {
    color: $cc-resmed-white;
  }

  h4 {
    font-weight: 400;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    margin-bottom: 0;
  }
}
</style>